
export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/34602365996"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-40 bg-green-500 hover:bg-green-600 text-white w-14 h-14 flex items-center justify-center rounded-full shadow-2xl transition-all duration-300 hover:scale-110 animate-bounce"
      aria-label="Contactar por WhatsApp"
      style={{ animationDuration: '2s' }}
    >
      <i className="ri-whatsapp-line text-3xl"></i>
    </a>
  );
}
